import React from "react";
import {
  AboutContent,
  AboutDetailsContainer,
  AboutImage,
  StyledAbout,
  Resume,
  ResumeLink,
} from "../styles/About.styled";
import { SectionHeading, SectionTitle } from "../styles/SectionHeading";
import { StyledParagraph } from "../styles/Typography.styled";
// import downloadIcon from "../../assets/icons/download-icon.svg";
import profile_pic from "../../assets/profile_pic.png";
// import picture from "../../assets/picture.jpg";

const About = () => {
  return (
    <StyledAbout id="about">
      <SectionHeading dark="true" mb="3rem">
        <SectionTitle dark="true" number="01">
          About Me
        </SectionTitle>
      </SectionHeading>
      <AboutContent>
        {/* <AboutImageContainer>
          <AboutImage  src={profile}/>
        </AboutImageContainer> */}
        <AboutImage src={profile_pic} />
        <AboutDetailsContainer>
          <StyledParagraph>
            As a seasoned Full Stack Developer based in Pune, Maharashtra, I
            specialize in both frontend and backend development, with a strong
            proficiency in Java, JavaScript, and Python. I have extensive
            experience with frameworks such as Spring Boot, ReactJS, and Django,
            allowing me to deliver robust and innovative solutions.
          </StyledParagraph>
          <StyledParagraph>
            My journey in software development is driven by a commitment to
            continuous learning and leveraging cutting-edge technologies. I
            specialize in integrating Generative AI and Prompt Engineering into
            development processes, enhancing efficiency and operational
            workflows.
          </StyledParagraph>
          <StyledParagraph>
            I am passionate about the future of technology and eager to
            contribute to groundbreaking projects. Let’s connect and explore how
            my skills can elevate your tech initiatives!
          </StyledParagraph>
          <Resume>
            <ResumeLink
              href="https://drive.google.com/file/d/10LfP8SnhcHtTcmJuvuFvdPHun7LkjHeL/view?usp=drive_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Resume
            </ResumeLink>
          </Resume>
        </AboutDetailsContainer>
      </AboutContent>
    </StyledAbout>
  );
};

export default About;
